import { ChartServiceOptions } from '@shared/highcharts/char-service-options';
import { ChartPointOptions } from '@shared/highcharts/chart-point-options';
import { Point } from 'highcharts';
import { TaxStatusThreshold } from '../enums/tax-status-threshold';

export function selectHandler(this: Point): void {
  const selectedOption = this.options as ChartPointOptions;
  const value: number = selectedOption.value;
  const selectedCountryCodeInstance = (
    this.series.chart.options.chart as ChartServiceOptions
  ).selectedCountryCode;

  if (value !== TaxStatusThreshold.NoInvestment) {
    selectedCountryCodeInstance.set(selectedOption['hc-key']);
  } else {
    selectedCountryCodeInstance.set(undefined);
  }
}
